import { useState } from 'react'
import { Crosshair, Loader2 } from 'lucide-react'

interface GpsButtonProps {
  /** Wird mit "lat, lon" (6 Nachkommastellen) aufgerufen – gleiches Format wie der MapPicker. */
  onCoords: (value: string) => void
  disabled?: boolean
  title?: string
}

/**
 * Button neben einem Ortsfeld: übernimmt die aktuellen GPS-Koordinaten des Geräts.
 * Gleiches Verhalten wie der GPS-Button im Einsätze-Modul (MapPicker).
 */
export function GpsButton({ onCoords, disabled = false, title = 'Aktuelle GPS-Koordinaten übernehmen' }: GpsButtonProps) {
  const [laedt, setLaedt] = useState(false)

  const hole = () => {
    if (!navigator.geolocation) {
      alert('Geolocation wird von diesem Browser nicht unterstützt')
      return
    }
    setLaedt(true)
    navigator.geolocation.getCurrentPosition(
      pos => {
        const { latitude, longitude } = pos.coords
        onCoords(`${latitude.toFixed(6)}, ${longitude.toFixed(6)}`)
        setLaedt(false)
      },
      err => {
        alert('Standort konnte nicht ermittelt werden: ' + err.message)
        setLaedt(false)
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
    )
  }

  return (
    <button
      type="button"
      onClick={hole}
      disabled={disabled || laedt}
      title={title}
      aria-label={title}
      className="mt-1.5 flex items-center justify-center w-12 h-12 shrink-0 rounded-xl border border-dark-border text-primary-400 hover:bg-primary-400/10 hover:text-primary-300 transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
    >
      {laedt ? <Loader2 className="h-5 w-5 animate-spin" /> : <Crosshair className="h-5 w-5" />}
    </button>
  )
}
